<template>
  <ImageGenParamsSSE @submit="onSubmit" />
</template>

<script>
import { RESUME_COMMAND_TYPE } from '~/constants/conversationModels';
import useConversations from '~/composables/useConversations';
import ImageGenParamsSSE from './ImageGenParamsSSE.vue';

// The image-gen half of what used to be InterruptBlockSSE.vue's single component.
// The HITL tool-review half is HitlReviewInterrupt.vue — unrelated features that only
// shared a pill/expansion-panel wrapper, which stays in InterruptBlockSSE.vue.
export default {
  name: 'ImageStyleChoiceInterrupt',
  components: { ImageGenParamsSSE },
  emits: ['submitted'],
  setup(props, { emit }) {
    const { resumeConversation } = useConversations();

    // Emit before awaiting: collapses the parent's panel to its pill immediately
    // and unmounts this form (prevents double-submit too).
    const onSubmit = async (imageGenerationParams) => {
      emit('submitted');
      await resumeConversation({ type: RESUME_COMMAND_TYPE.IMAGE_STYLE_CHOICES_RESPONSE, imageGenerationParams });
    };

    return { onSubmit };
  },
};
</script>
